window.onload = function () {
	document.querySelectorAll("h2.disclosure__title").forEach((title) => {
		console.log("title", title.textContent.trim());
		if (title.textContent.trim() === "Suggested Recipes") {
			const detailsDisclosure = title.closest("details-disclosure");
			console.log("detailsDisclosure", detailsDisclosure);
			if (detailsDisclosure) {
				detailsDisclosure.remove();
				// detailsDisclosure.classList.add("d-none");
			}
		} else if (title.textContent.trim() === "Ingredients") {
			const detailsDisclosure = title.closest("details-disclosure");
			console.log("detailsDisclosure", detailsDisclosure);
			if (detailsDisclosure) {
				detailsDisclosure.remove();
				// detailsDisclosure.classList.add("d-none");
		}
	}
		else {
			console.warn("No matching title found for 'Suggested Recipes'.");
		}
	});
};
